
import React, { useEffect, useContext, useState } from 'react'
import { SpinnerComponent } from 'react-element-spinner'
import {
	Button,
	Card,
	CardBody,
	CardFooter,
	CardHeader,
	Col,
	Container,
	FormGroup,
	Input,
	Label,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row
} from 'reactstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import VehicleInspectionsService from '../../../../services/VehicleInspectionsService'
import { AuctionsContext } from '../../../../contexts/AuctionsProvider'
import { SessionContext } from '../../../../contexts/SessionProvider'
import SiteService from '../../../../services/SiteService'
import { InspectionsContext } from '../../../../contexts/InspectionsProvider'
import PageTitleContextMenu from '../../../../components/PageTitles/PageTitleContextMenu'
import AuctionsNavBar from '../../../../components/Navbars/AuctionsNavBar'

const AuctionPictures = ({ embedded = false, onRequestClose, onSelectDetailTab }) =>
{
	const { t } = useTranslation()
	const [isBusy, setIsBusy] = React.useState(false)
	const auctionsContext = useContext(AuctionsContext)
	const sessionContext = useContext(SessionContext)
	const [selectedPicFilePath, setSelectedPicFilePath] = useState('')
	const inspectionsContext = useContext(InspectionsContext)
	const [openConfirmDeletePic, setOpenConfirmDeletePic] = useState(false)
	const [showFileUploadModal, setShowFileUploadModal] = useState(false)
	const [pictureFile, setPictureFile] = useState()
	const [pictureFileName, setPictureFileName] = useState()
	const [vehicleInspectionId, setVehicleInspectionId] = useState('')
	const [pictureTypes, setPictureTypes] = useState([])
	const [pictureTypeId, setPictureTypeId] = useState('')
	const navigate = useNavigate()

	useEffect(() =>
	{
		initializeComponent()
	}, [])

	const initializeComponent = () =>
	{
		setPictureTypes([
			'3/4 VIEW - LEFT FRONT',
			'3/4 VIEW - LEFT REAR',
			'3/4 VIEW - RIGHT FRONT',
			'3/4 VIEW - RIGHT REAR',
			'CENTER CONSOLE/GEAR SHIFT',
			'EMISSIONS LABEL',
			'ENGINE',
			'FRONT BUMPER',
			'FRONT LEFT WHEEL/COVER',
			'FRONT RIGHT WHEEL/COVER',
			'HOOD/COWL',
			'INST PANEL',
			'INTERIOR - DRIVERS SIDE',
			'INTERIOR - REAR',
			'INTERIOR ROOF',
			'KEYS/MANUALS',
			'ODOMETER',
			'REAR BUMPER',
			'REAR LEFT WHEEL/COVER',
			'REAR RIGHT WHEEL/COVER',
			'RIGHT REAR DOOR',
			'ROOF',
			'SEAT - LEFT FRONT',
			'SEAT - RIGHT FRONT',
			'SERIES/TRIM',
			'THIRD SEAT',
			'TIRE INFO STICKER',
			'TRUNK/BED',
			'UNDERCARRIAGE - FRONT',
			'UNDERCARRIAGE - LEFT',
			'UNDERCARRIAGE - RIGHT',
			'UNDERCARRIAGE- REAR',
			'VIN',
			'WINDSHIELD',
			'WINDSHIELD BRAND LOGO'
		])
		setPictureTypeId('3/4 VIEW - LEFT FRONT')

		retrieveVehicleInspectionPictures()
	}

	const retrieveVehicleInspectionPictures = () =>
	{
		setIsBusy(true)
		VehicleInspectionsService
			.getVehicleInspectionPictures(auctionsContext.auction.auctionId, sessionContext.loginSession.user.userSession.sessionKey)
			.then(result =>
			{
				setIsBusy(false)
				sessionContext.updateSession(result.data.loginSession)

				if (result.data.actionResult && result.data.actionResult.length > 0)
				{
					setVehicleInspectionId(result.data.actionResult[0].vehicleInspectionId)
				}
				inspectionsContext.setVehicleInspectionPictures(result.data.actionResult)
			})
			.catch((error) =>
			{
				setIsBusy(false)
				SiteService.displayApiError(error)
			})
	}

	const handleSmallInspectionPicClicked = (filePath) =>
	{
		setSelectedPicFilePath(filePath)
	}

	const handleLargeInspectionPicClicked = () =>
	{
		setSelectedPicFilePath('')
	}

	const handleConfirmDeleteInspectionPic = () =>
	{
		setOpenConfirmDeletePic(true)
	}

	const handleDeleteInspectionPic = (e) =>
	{
		e.preventDefault()
		setOpenConfirmDeletePic(false)
		setSelectedPicFilePath('')

		const pic = inspectionsContext.vehicleInspectionPictures.find(vehicleInspectionPicture => vehicleInspectionPicture.filePath === selectedPicFilePath)

		if (pic)
		{
			setIsBusy(true)
			VehicleInspectionsService
				.deleteVehicleInspectionPicture(pic.vehicleInspectionPictureId, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)

					retrieveVehicleInspectionPictures()
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
	}

	const handleFileChange = (event) =>
	{
		setPictureFile(event.target.files[0])
		setPictureFileName(event.target.files[0].name)
	}

	const handlePictureTypeChange = (e) =>
	{
		const { name, value} = e.target
		setPictureTypeId(value)
	}

	const handleFileUpload = () =>
	{
		if (pictureFile && pictureFileName && pictureTypeId)
		{
			let formData = new FormData()
			formData.append('file', pictureFile)
			formData.append('fileName', pictureFileName)
			formData.append('pictureTypeId', pictureTypeId)
			formData.append('vehicleInspectionId', vehicleInspectionId)

			setIsBusy(true)
			VehicleInspectionsService
				.uploadVehicleInspectionPicture(formData, sessionContext.loginSession.user.userSession.sessionKey)
				.then(result =>
				{
					setIsBusy(false)
					sessionContext.updateSession(result.data.loginSession)

					setShowFileUploadModal(false)
					retrieveVehicleInspectionPictures()
				})
				.catch((error) =>
				{
					setIsBusy(false)
					SiteService.displayApiError(error)
				})
		}
	}
	
	const handleGoBack = () =>
	{
		if (embedded)
		{
			if (typeof onRequestClose === 'function') onRequestClose()
			return
		}
		navigate('/secure/auctions-listing')
	}

	return (
		<div style={{
			zIndex: 500
		}}>
			<SpinnerComponent
				loading={ isBusy }
				position="global"
				color="#3578e5"
				secondaryColor="#f3f3f3"
				backgroundColor="#d3d3d3"
				spinnerType="circle-dots"
				style={{ zIndex: 9999 }}
			/>
			{
				!embedded &&
				<PageTitleContextMenu
					heading={ t('Auctions.Pictures.Title') }
					subheading={ auctionsContext.auction.auctionVehicle.vehicle.year + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.make + ' ' +
						auctionsContext.auction.auctionVehicle.vehicle.model + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.trim + ' / ' +
						auctionsContext.auction.auctionVehicle.vehicle.serialNumber
					}
					icon="pe-7s-ticket icon-gradient bg-premium-dark"
					headerOptions={ { showBack: true, backCommand: () => { handleGoBack() }, showReload: false, reloadCommand: null } }
				/>
			}
			<Container className={ embedded ? "" : "mt--6" } fluid>
				<Row>
					<div className="col">
						<Card>
							<CardHeader style={{padding: '0.5rem 0.75rem'}}>
								<AuctionsNavBar
									parentComponent={'auction-pictures'}
									onSelect={ embedded ? onSelectDetailTab : undefined }
								/>
							</CardHeader>
							<CardBody>
								<Col md="12">
									<Row style={{ marginBottom: '10px' }}>
										<Col>
											<div className="text-right">
												<Button
													color="secondary"
													size="sm"
													type="button"
													onClick={ () => setShowFileUploadModal(true) }
												>
													Upload Picture
												</Button>
											</div>
										</Col>
									</Row>
									<Row>
										{inspectionsContext.vehicleInspectionPictures.map((picture, idx) => (
											<Col key={ idx } sm="1" style={{ marginBottom: '10px' }}>
												<img
													key={ idx }
													className="inspection-pic-sm"
													src={ picture.filePath }
													width="100px"
													height="100px"
													alt="..."
													onClick={ () => { handleSmallInspectionPicClicked(picture.filePath) } }
													style={{ cursor: 'pointer' }}
												/>
											</Col>
										))}
									</Row>
									{
										inspectionsContext.vehicleInspectionPictures.length === 0 &&
										<Row style={{ marginTop: '20px' }}>
											<Col md="12" style={{ textAlign: 'center' }}>
												<label>{ t('Auctions.Pictures.No_Results') }</label>
											</Col>
										</Row>
									}
								</Col>
							</CardBody>
							<CardFooter></CardFooter>
						</Card>
					</div>
				</Row>

				<Modal
					size="lg"
					isOpen={selectedPicFilePath.length > 0}
					toggle={() => handleLargeInspectionPicClicked()}
				>
					<ModalHeader toggle={ () => handleLargeInspectionPicClicked() } charCode="Y"></ModalHeader>
					<ModalBody>
						<Card className="border-0 mb-0">
							<CardBody>
								<div className="text-center">
									<img className="inspection-pic-lg" src={selectedPicFilePath} width="700px" height="600px" alt="..."/>
								</div>
								<div className="text-center">
									<Button
										className="my-4"
										color="danger"
										type="button"
										onClick={() => handleConfirmDeleteInspectionPic()}
									>
										Delete
									</Button>
									<Button
										className="my-4"
										color="primary"
										type="button"
										onClick={() => handleLargeInspectionPicClicked()}
										style={{ marginLeft: '10px' }}
									>
										Close
									</Button>
								</div>
							</CardBody>
						</Card>
					</ModalBody>
				</Modal>
				
				<Modal
					isOpen={ openConfirmDeletePic }
					toggle={ () => setOpenConfirmDeletePic(false) }
				>
					<ModalHeader toggle={ () => setOpenConfirmDeletePic(false) } charCode="Y"></ModalHeader>
					<ModalBody>
						<Card className="border-0 mb-0">
							<CardHeader>
								<div className="modal-header">
									<Label className="modal-title" id="modal-title-default">
										<Label className="mb-0">Delete Inspection Picture</Label>
									</Label>
								</div>
							</CardHeader>
							<CardBody>
								<div className="modal-body"><p>Are you certain that you want to delete this picture?</p></div>
							</CardBody>
							<CardFooter>
								<Row style={{ width: '100%' }}>
									<Col md={6}>
										<Button
											block
											color="secondary"
											className="btn-block"
											onClick={ () => setOpenConfirmDeletePic(false) }
										>
											{ t('Common.No') }
										</Button>
									</Col>
									<Col md={6}>
										<Button
											block
											color="primary"
											className="btn-block"
											onClick={(event) => { handleDeleteInspectionPic(event) }}
										>
											{ t('Common.Yes') }
										</Button>
									</Col>
								</Row>
							</CardFooter>
						</Card>
					</ModalBody>
					<ModalFooter></ModalFooter>
				</Modal>

				<Modal
					isOpen={ showFileUploadModal }
					toggle={ () => setShowFileUploadModal(false) }
				>
					<ModalHeader toggle={ () => setShowFileUploadModal(false) } charCode="Y"></ModalHeader>
					<ModalBody>
						<Card className="border-0 mb-0">
							<CardHeader>
								<div className="modal-header">
									<Label className="modal-title" id="modal-title-default">
										<Label className="mb-0">Upload Picture</Label>
									</Label>
								</div>
							</CardHeader>
							<CardBody>
								<div className="modal-body">
									<FormGroup className="row">
										<Label className="form-control-label" md="4" >
											{ t('Auctions.Pictures.Picture_Type') }
										</Label>
										<Col md="8">
											<Input
												name="pictureTypeId"
												type="select"
												value={ pictureTypeId }
												onChange={ handlePictureTypeChange }
											>
												{
													pictureTypes.map((pictureType, idx) =>
													{
														return (
															<option value={ pictureType } key={ idx }>{ pictureType }</option>
														)
													})
												}
											</Input>
										</Col>
									</FormGroup>
									<FormGroup className="row">
										<Label className="form-control-label" md="4" >
											{ t('Auctions.Pictures.File') }
										</Label>
										<Col md="8">
											<Input
												name="pictureFile"
												type="file"
												onChange={ handleFileChange }
											/>
										</Col>
									</FormGroup>
								</div>
							</CardBody>
							<CardFooter>
								<Button block className="btn-block btn-default" size="lg" type="button" onClick={ handleFileUpload }>
									{ t('Auctions.Pictures.Submit') }
								</Button>
							</CardFooter>
						</Card>
					</ModalBody>
					<ModalFooter></ModalFooter>
				</Modal>

			</Container>
		</div>
	)
}

export default AuctionPictures
